import React from 'react'
import logo from './logoChlaep.png';
import { SketchPicker } from 'react-color';



const Logo = () => {
    return (
        <>
            {/*<div style={{ height: '120px', width: '100%', backgroundColor: "#BBDEFB"}}>*/}
            <div>
                <p style={{textAlign: 'left', marginBottom: '0%'}}><img src={logo} alt="" style={{ width: '30%'}}/></p>
            </div>
        </>
    )
}

export default Logo